import React, { useState, useEffect } from 'react';
import './PrivateLogin.css';
import { FaKey, FaArrowLeft, FaSpinner } from 'react-icons/fa';
import Dashboard from './Dashboard';

// Komponente für die animierten Punkte
const AnimatedEllipsis = () => {
  const [dots, setDots] = useState('');
  
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length < 3 ? prev + '.' : ''));
    }, 500);
    return () => clearInterval(interval);
  }, []);
  
  return <span>{dots}</span>;
};

const PrivateLogin = () => {
  const [productKey, setProductKey] = useState("");
  const [verifying, setVerifying] = useState(false);
  const [resultMessage, setResultMessage] = useState("");
  const [resultColor, setResultColor] = useState("");
  const [isValidKey, setIsValidKey] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [keyStatus, setKeyStatus] = useState("");
  const [expiryValue, setExpiryValue] = useState(null);
  const [downloadLink, setDownloadLink] = useState("");

  // Einfach jeden eingegebenen Wert übernehmen
  const handleInputChange = (e) => {
    setProductKey(e.target.value);
  };

  const handleFocus = () => {
    setProductKey("");
  };

  // Enter zum Verifizieren, sonst nichts weiter
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleVerify();
    }
  };

  const handleVerify = async () => {
    setVerifying(true);
    setResultMessage("");
    const apiUrl = "https://eaglescript.space:8443/check-key"; // <- Direkter Port
    const headers = { "Content-Type": "application/json" };
    const payload = { key: productKey };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
      });

      let message = "";
      let color = "";
      let valid = false;

      if (!response.ok) {
        message = "Key not valid.";
        color = "red";
      } else {
        const data = await response.json();
        if (data.status === "activated" || data.status === "not activated") {
          message = "Key is valid.";
          color = "#CAF881";
          valid = true;
          setKeyStatus(data.status);
          setExpiryValue(data.status === "not activated"
            ? data.duration
            : data.remaining_seconds
          );
          setDownloadLink(data.download_link);
        } else {
          message = "Key not valid.";
          color = "red";
        }
      }

      // Mindestens 2 Sekunden Spinner anzeigen
      setTimeout(() => {
        setResultMessage(message);
        setResultColor(color);
        setIsValidKey(valid);
        setVerifying(false);
        if (valid) {
          setTimeout(() => setLoggedIn(true), 2000);
        }
      }, 2000);

    } catch (err) {
      setTimeout(() => {
        setResultMessage("Key not valid.");
        setResultColor("red");
        setIsValidKey(false);
        setVerifying(false);
      }, 2000);
    }
  };

  if (loggedIn) {
    return (
      <Dashboard 
        productKey={productKey} 
        keyStatus={keyStatus} 
        expiryValue={expiryValue} 
        downloadLink={downloadLink}
      />
    );
  }

  return (
    <div className="private-login-page" id="private-login">
      <div className="private-login-container">
        <h2>Enter your product key:</h2>
        <input
          type="text"
          className="product-key-input"
          placeholder="Enter your product key"
          value={productKey}
          onChange={handleInputChange}
          onFocus={handleFocus}
          onKeyDown={handleKeyDown}
        />
        <div className="api-response" style={{ margin: '5px 0 15px', textAlign: 'center' }}>
          {verifying ? (
            <div className="verifying" style={{ color: 'white' }}>
              <FaSpinner className="spinner" style={{ marginRight: '0.5rem' }} />
              <span>Verifying code...</span>
            </div>
          ) : (
            resultMessage && (
              isValidKey ? (
                <div>
                  <p style={{ margin: 0, color: resultColor }}>{resultMessage}</p>
                  <p style={{ margin: 0, color: resultColor, fontWeight: '900', fontSize: '1em' }}>
                    Forwarding to dashboard<AnimatedEllipsis />
                  </p>
                </div>
              ) : (
                <p style={{ margin: 0, color: resultColor }}>{resultMessage}</p>
              )
            )
          )}
        </div>
        <div className="private-login-buttons">
          <button className="private-login-button verify-button" onClick={handleVerify}>
            <FaKey className="icon" />
            <span>Verify</span>
          </button>
          <a href="https://eaglescript.space/" className="private-login-button back-button">
            <FaArrowLeft className="icon" />
            <span>Back to homepage</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrivateLogin;
